export enum WEBVIEW_TYPE_ENTRY {
  KB_PAY = 'KB_PAY',
  TOSS = 'TOSS',
  KAKAO_BANK = 'KAKAO_BANK',
  WELLO = 'WELLO',
}
